module.exports = __webpack_public_path__ + "img/HZ-B4003.a71bcb81.jpg";